
import React from 'react';

const FooterLanding: React.FC = () => {
    return (
        <footer className="bg-gray-800 text-white">
            <div className="container mx-auto px-6 py-8">
                <div className="flex flex-col items-center sm:flex-row sm:justify-between">
                    <div className="text-center sm:text-left">
                        <img src="/logo.png" alt="Tu Club" className="h-8 mb-2 mx-auto sm:mx-0" />
                        <p className="text-gray-400 mt-2">Simplificando la gestión de tu club.</p>
                    </div>
                    <div className="mt-4 sm:mt-0">
                        <div className="flex space-x-4">
                            <a href="#" className="text-gray-400 hover:text-white">Facebook</a>
                            <a href="#" className="text-gray-400 hover:text-white">Twitter</a>
                            <a href="#" className="text-gray-400 hover:text-white">Instagram</a>
                        </div>
                    </div>
                </div>
                <div className="mt-8 border-t border-gray-700 pt-4 text-center text-gray-500 text-sm">
                    &copy; {new Date().getFullYear()} Tu Club. Todos los derechos reservados.
                </div>
            </div>
        </footer>
    );
};

export default FooterLanding;
